import { render, staticRenderFns } from "./SingleSelect.vue?vue&type=template&id=5ccd3508&scoped=true&"
import script from "./SingleSelect.vue?vue&type=script&lang=ts&"
export * from "./SingleSelect.vue?vue&type=script&lang=ts&"
import style0 from "./SingleSelect.vue?vue&type=style&index=0&id=5ccd3508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccd3508",
  null
  
)

/* custom blocks */
import block0 from "./SingleSelect.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports